import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=049a9fc2&scoped=true&"
import script from "./VideoDetail.vue?vue&type=script&lang=js&"
export * from "./VideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=049a9fc2&prod&scoped=true&lang=less&"
import style1 from "./VideoDetail.vue?vue&type=style&index=1&id=049a9fc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a9fc2",
  null
  
)

export default component.exports